<script lang="ts">
export default {
  name: 'KkInfo',
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { KkIcon } from '../../base'
import type { IconName } from '../../base/KkIcon/index.vue'

interface Props {
  alert?: boolean
  icon?: IconName
}

const props = withDefaults(defineProps<Props>(), {
  alert: false,
  icon: 'hint'
})

const classes = computed<string[]>(() => {
  const classes = ['info']
  if (props.alert) classes.push('--alert')
  return classes
})

const iconColor = computed<string>(() => {
  return props.alert ? '#FFF' : '#3A3B3F'
})
</script>

<template>
  <div :class="classes">
    <div class="info__icon">
      <KkIcon :name="icon" :color="iconColor" />
    </div>
    <div class="info__text">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../../../stylesheets/biz_spa/foundation/_mixin.scss';
.info {
  display: inline-flex;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  background-color: #F5F6F9;
  &__icon {
    flex: 0 0 16px;
    min-width: 16px;
  }
  &__text {
    margin-left: 8px;
    font-size: 12px;
    line-height: 1.5;
    white-space: pre-wrap;
  }
  &.--alert {
    background-color: #E9446A;
    color: #FFF;
  }
  + .info {
    margin-top: 8px;
  }
}
</style>
